var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZonePdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2982 7.7V0.5H15.35L18.5 3.65V20.3H1.4M14 0.5V5H18.5M12.65 16.7V10.4H16.25M12.65 13.55H15.35M0.5 10.4H1.85C3.65 10.4 3.875 11.525 3.875 12.2C3.875 12.875 3.65 14 1.85 14H0.725V15.8H0.5V10.4ZM6.35 15.8V10.4H7.8845C8.9078 10.4 9.95 10.85 9.95 13.1C9.95 15.35 8.9078 15.8 7.8845 15.8H6.35Z",
    stroke: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZonePdfIcon);
export default __webpack_public_path__ + "static/media/zonePdfIcon.4977604bede8c14f9780111225f9695b.svg";
export { ForwardRef as ReactComponent };